export default {
  'ov.sys.title.os': {
    ko: 'Operating System',
    ja: 'オペレーティングシステム',
    en: 'Operating System',
  },
  'ov.sys.title.throughput': {
    ko: 'Throughput',
    ja: 'スループット',
    en: 'Throughput',
  },
  'ov.sys.title.upd.record.error.abbr': {
    ko: 'Upd. Rec.(Err.)',
    ja: 'レコード更新(Err.)',
    en: 'Upd. Rec.(Err.)',
  },
  'logon.user.type.32': {
    ko: 'RFC',
    ja: 'RFC',
    en: 'RFC',
  },
  'ov.sys.title.mem': {
    ko: 'Memory',
    ja: 'メモリ',
    en: 'Memory',
  },
  'ov.sys.title.logon.user': {
    ko: 'Logon User',
    ja: 'ログオンユーザー',
    en: 'Logon User',
  },
  'ov.sys.title.swap': {
    ko: 'Swap',
    ja: 'SWAP',
    en: 'Swap',
  },
  'ov.sys.title.logon.dup': {
    ko: 'Logon Duplication',
    ja: 'ログオン重複',
    en: 'Logon Duplication',
  },
  'ov.sys.title.event': {
    ko: 'Event',
    ja: 'イベント',
    en: 'Event',
  },
  'ov.sys.title.owlview': {
    ko: 'OWL View',
    ja: 'OWLビュー',
    en: 'OWL View',
  },
  'ov.sys.title.exclusive.lock': {
    ko: 'Exclusive Lock',
    ja: 'エクスクルーシブロック',
    en: 'Exclusive Lock',
  },
  'logon.user.type.202': {
    ko: 'Plugin',
    ja: 'プラグイン',
    en: 'Plugin',
  },
  'ov.sys.title.sstm.sum': {
    ko: 'System Summary',
    ja: 'システム概要',
    en: 'System Summary',
  },
  'ov.sys.title.run.workprcs': {
    ko: 'Running Workprocess',
    ja: 'ワークプロセスを実行中',
    en: 'Running Workprocess',
  },
  'ov.sys.title.enqueue.lock': {
    ko: 'Enqueue Lock',
    ja: 'エンキューロック',
    en: 'Enqueue Lock',
  },
  'ov.sys.title.rt': {
    ko: 'Response Time',
    ja: '応答時間',
    en: 'Response Time',
  },
  'ov.sys.title.logon.dup.abbr': {
    ko: 'Logon Dup.',
    ja: 'ログオン重複',
    en: 'Logon Dup.',
  },
  'ov.sys.title.upd.record': {
    ko: 'Update Record',
    ja: 'レコード更新',
    en: 'Update Record',
  },
  'ov.sys.title.inst.sum': {
    ko: 'Instance Summary',
    ja: 'インスタンスサマリー',
    en: 'Instance Summary',
  },
  'ov.sys.title.workprcs': {
    ko: 'Workprocess',
    ja: 'ワークプロセス',
    en: 'Workprocess',
  },
  'ov.sys.title.ext.mem': {
    ko: 'Extended Memory',
    ja: '拡張メモリ',
    en: 'Extended Memory',
  },
  'ov.sys.title.heap.mem': {
    ko: 'Heap Memory',
    ja: 'ヒープメモリ',
    en: 'Heap Memory',
  },
  'logon.user.type.4': {
    ko: 'GUI',
    ja: 'GUI',
    en: 'GUI',
  },
  'ov.sys.title.cpu': {
    ko: 'CPU',
    ja: 'CPU',
    en: 'CPU',
  },
  'ov.sys.title.abap.dump': {
    ko: 'ABAP Dump',
    ja: 'ABAPダンプ',
    en: 'ABAP Dump',
  },
  'logon.user.type.2': {
    ko: 'System',
    ja: 'システム',
    en: 'System',
  },
  // FINISH::Added.by.KWShin.2024.03.22.
  // BEGIN::Added.by.KWShin.2025.11.19.
  'ov.sys.title.http.sssn': {
    ko: 'Http Session',
    en: 'Http Session',
  },
  // FINISH::Added.by.KWShin.2025.11.19.
};
